import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { ReactComponent as FilterAltOutlinedIcon } from '../../../static/icons/filter.svg';
import Card from '@mui/material/Card';
import * as React from 'react';
import { getFilters, getFiltersNew, getOverallQueueCounter, getQueueCounter } from '../../../services/api-service';
import FilterDrawer from '../../FilterDrawer/FilterDrawer';
import OZTable from '../../OZTable/OZTable';
import WidgetDownload from '../../Widget-Download/Widget-Download';
import WidgetGraph from '../../Widget-Graph/Widget-Graph';

import { Badge, Box, Chip, Stack, Grid } from '@mui/material';
import { WIDGET_REFRESH_INTERVAL } from '../../../utils/constants';
import '../OverallQueueCounter/OverallQueueCounter.css';
import ThresholdDrawer from '../../ThresholdDrawer/ThresholdDrawer';
import { mapRowDataWithThreshold, mapRowDataWithThresholdNew } from '../../../utils/util';
import useChartResize from '../../../hooks/useChartResize';
import { getLastFetchedDetailFromBrowser } from '../../../services/application-service';


const thresholdFields = [
	{ label: 'Longest wait time', value: '', key: 'LongestWaitTime', condition: 'GREATER_THAN' },
	{ label: 'Calls Waiting', value: '', key: 'QueueCount', condition: 'GREATER_THAN' }
];

export default function OverallQueueCounter(props: any) {
	const { useState, useRef } = React;
	const [isDrawerOpen, setIsDrawerOpen] = useState<boolean | undefined>(false);
	const [filterType, setFilterType] = useState<any>(props?.selectedFilters?.filterSection?.id || 5);
	const [filterSection, setFilterSection] = useState<any>(props?.selectedFilters?.filterSection || {});
	const [responseLength, setresponseLength] = useState<Number>(0);
	const [rowData, setRowData] = useState<Array<any>>([]);
	const [columnData, setColumnData] = useState<Array<any>>([]);
	const [thresholdItems, setThresholdItems] = useState<Array<any>>([]);
	const [overallqueueCounterFilter, setOverallQueueCounterFilter] = useState<Array<any>>(props?.selectedFilters?.filters || []);
	const [isThresholdDrawerOpen, setIsThresholdDrawerOpen] = useState<boolean | undefined>(false);
	const [lastFetchedTime, setLastFetchedTime] = useState<any>('');
	const downloadContent = useRef<null | any>(null);
	const { chartContainerRef, chartDimensions } = useChartResize();

	const intervalRef = useRef<any>(null);
	const isWidgetDataLoadingRef = useRef<boolean>(false);

	const retrieveTableData = async (filters = '0') => {
		try {
			if (isWidgetDataLoadingRef.current) {
				console.log('Widget data fetch already in progress, skipping this cycle OverallQueueCounter');
				return;
			};
			isWidgetDataLoadingRef.current = true;
			const columns = [
				{ name: 'Skill Location', key: 'LocationName' },
				{ name: 'Skill Details', key: 'SkillDetail1' },
				{ name: 'Calls Waiting', key: 'QueueCount' },
			];
			let rows: any = await getOverallQueueCounter({ filters, type: filterType });
			rows = rows?.map((row: any) => {
				let rowObj = {
					...row,
					LocationName: row.LocationName ? 'All' : 'All',
				};
				return rowObj;
			});
			// const updatedRowData = mapRowDataWithThreshold(thresholdItems, rows);
			const updatedRowData = mapRowDataWithThresholdNew(thresholdItems, rows);
			setRowData(updatedRowData);
			setColumnData(columns);
			setLastFetchedTime(getLastFetchedDetailFromBrowser());
		}
		catch (error) {
			console.error('Error fetching overall queue counter:', error);
		}
		finally {
			isWidgetDataLoadingRef.current = false;
		}
	};

	const handleDownload = (type: string) => {
		console.log(type);
	};

	const toggleDrawer = (isOpen: boolean) => {
		setIsDrawerOpen(isOpen);
	};

	const handleFilterDelete = (id: Number) => {
		const newFilter = overallqueueCounterFilter.filter((item: any) => item.id !== id);
		setOverallQueueCounterFilter(newFilter);
		props?.handleFilterChange?.(newFilter, filterSection, props?.widgetId);
	};

	const clearFilter = () => {
		console.info('Clear all filter.');
		setOverallQueueCounterFilter([]);
		props?.handleFilterChange?.([], filterSection, props?.widgetId);
	};

	const handleFilterExistingData = (filteredData: any) => {
		setOverallQueueCounterFilter(filteredData);
		props?.handleFilterChange?.(filteredData, filterSection, props?.widgetId);
	};

	const handleApplyFilters = ({ selectedFilters, filterType: newFilterType, filterSection: newfilterSection }: any) => {
		setOverallQueueCounterFilter(selectedFilters);
		setFilterType(newFilterType);
		setFilterSection(newfilterSection);
		props?.handleFilterChange?.(selectedFilters, newfilterSection, props?.widgetId);
		toggleDrawer(false);
	};

	const filterItems = overallqueueCounterFilter.map((item: any, index: number) => (
		<Chip key={index} label={item.label} color="primary" variant="outlined" onDelete={() => handleFilterDelete(item.id)} deleteIcon={<CloseOutlinedIcon style={{ fontSize: '12px' }} />} />
	));

	const toggleThresholdDrawer = (isOpen: boolean, data: any = null) => {
		setIsThresholdDrawerOpen(isOpen);
		if (data) {
			setThresholdItems(data);
		}
	};

	const updateThresholdItems = async () => {
		let newThresholdItems = [];
		const response: any = await getFilters('Location');
		newThresholdItems.push({ label: 'Organization Level', fields: thresholdFields, isOrgSkill: true });
		for (const row of response) {
			if (row.name !== 'All') {
				newThresholdItems.push({ label: row.Name, key: 'SkillName', value: row.Name, fields: thresholdFields });
			}
		}
		setThresholdItems(newThresholdItems);
	};

	React.useEffect(() => {
		updateThresholdItems();
		return () => {
			clearInterval(intervalRef.current);
		};
	}, []);

	React.useEffect(() => {
		const filterIds = overallqueueCounterFilter.length ? overallqueueCounterFilter.map((item: any) => item.id).join(',') : '0';
		retrieveTableData(filterIds);
		if (intervalRef.current) {
			clearInterval(intervalRef.current);
		}
		intervalRef.current = setInterval(() => retrieveTableData(filterIds), WIDGET_REFRESH_INTERVAL.OVERALL_QUEUE_COUNTER);
	}, [overallqueueCounterFilter, thresholdItems]);

	function getRowData(row: any) {
		row = row?.map((item: any) => {
			let rowObj = {
				...item,
				LocationName: row.LocationName ? 'All' : 'All',
			};
			return rowObj;
		});
		return row;
	}

	return (
		<Card className="customCard">
			<div className="card-header">
				<div className="card-title">
					Overall Queue Counter<div className="card-title-badge">Live</div>
					<span className="last-fetched-time" style={{ marginLeft: '6px' }}>Last updated at {lastFetchedTime} </span>
				</div>
				<div className="card-actions">
					<WidgetDownload element={downloadContent} xlsx rowData={getRowData(rowData)} columns={columnData} handleDownload={handleDownload} name={'Overall Queue Counter'}></WidgetDownload>
					<div className="card-icon" onClick={() => toggleDrawer(true)}>
						<Badge badgeContent={overallqueueCounterFilter.length} color="primary">
							<FilterAltOutlinedIcon fontSize="small" style={{ color: '#536580' }} />
						</Badge>
					</div>
					{/* <div onClick={() => toggleThresholdDrawer(true)}>
						<WidgetGraph></WidgetGraph>
					</div> */}
				</div>
			</div>
			<FilterDrawer NewWidget isOpen={isDrawerOpen} toggleDrawer={toggleDrawer} applyFilters={handleApplyFilters} allowedFilters={['Detail']} existingSelectedFilters={overallqueueCounterFilter} existingFilterCategory={filterType} applyFilterOnExistingData={handleFilterExistingData} />
			{overallqueueCounterFilter.length > 0 && (<Box sx={{ width: '100%', typography: 'body1', background: "white" }}>
				<Box className='customTabPanel'>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<div className="filter-outer">
								<div className="filter-container">
									<Stack direction="row" spacing={1}>
										{filterItems}
									</Stack>
								</div>
								<div className="filter-remove" onClick={clearFilter}>
									Remove
								</div>
							</div>
						</Grid>
					</Grid>
				</Box>
			</Box>)}
			<Box ref={chartContainerRef} sx={{ height: overallqueueCounterFilter.length > 0 ? 'calc(100% - 118px)' : 'calc(100% - 46px)', }}>
				<OZTable columns={columnData} rows={rowData} maxHeight={360} downloadContent={downloadContent} noMaxHeight={true} height={chartDimensions.height * 1.05} />
			</Box>
			<ThresholdDrawer isOpen={isThresholdDrawerOpen} title={'Queue Counter'} toggleDrawer={toggleThresholdDrawer} thresholdItems={thresholdItems} />
		</Card>
	);
}
